angular.module('app.controllers').controller('GroupsListCtrl', function ($rootScope, $translate, notify, groupsListFilterFactory, api, formValidator, UserService, usersOptions) {
    const vm = this;

    vm.filter = groupsListFilterFactory;
    vm.usersOptions = usersOptions;
    vm.statusOptions = [
        { value: 'group_active', label: $translate.instant('group_active') },
        { value: 'group_inactive', label: $translate.instant('group_inactive') },
        { value: 'group_deleted', label: $translate.instant('group_deleted') },
    ];

    // dane użytkowników
    const GroupModel = api('groups');

    vm.groups = [];
    vm.loadList = () => {
        const info = notify.info($translate.instant('loading'));
        GroupModel.list().then((response) => {
            vm.groups = response.data;
            info.close();
            notify.success($translate.instant('loaded'));
        });
    };
    vm.loadList();

    // obsługa akcji
    const user = UserService;

    vm.currentGroup = {};
    vm.editGroup = (id) => {
        vm.currentGroup = angular.extend(
            {},
            _.find(vm.groups, { id }) || {
                author_id: user.getUser().id,
                owner_id: user.getUser().id,
                area_id: $rootScope.$session.area.id,
                status: 'group_active',
            }
        );
    };

    // form validation
    const fv = formValidator('#GroupForm', vm);

    vm.saveGroup = () => {
        if (!fv.isValid()) {
            return;
        }

        const info = notify.info($translate.instant('saving'));
        notify.global(1);

        GroupModel.save(vm.currentGroup.id || 0, vm.currentGroup).then((response) => {
            // zamiana/dodanie
            const index = _.findIndex(vm.groups, { id: vm.currentGroup.id || 0 });

            if (-1 !== index) {
                vm.groups[index] = response;
            } else {
                vm.groups.push(response);
            }

            GroupModel.clearCache();

            info.close();
            notify.success($translate.instant('saved'));
            notify.global(0);
        });
    };
});
